import Vue from "vue";
import Router from "vue-router";
import i18n from "@/i18n";
const LoginScreen = () => import("@/views/LoginScreen.vue");
const ForgotPasswordScreen = () => import("@/views/ForgotPasswordScreen.vue");
const ResetPasswordScreen = () => import("@/views/ResetPasswordScreen.vue");
const SuccessResetPasswordScreen = () => import("@/views/SuccessResetPasswordScreen.vue");
const AuthLoadingScreen = () => import('@/views/AuthLoadingScreen.vue')

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/",
      name: "loginScreen",
      component: LoginScreen,
    },
    {
      path: `/${i18n.t("forgotPasswordUrl")}`,
      name: "forgotPassword",
      component: ForgotPasswordScreen,
    },
    {
      path: "/reset-password/:token",
      name: "resetPassword",
      component: ResetPasswordScreen,
      props: true,
    },
    {
      path: `/${i18n.t("resetedPasswordUrl")}`,
      name: "successResetPassword",
      component: SuccessResetPasswordScreen,
    },
    {
      path: "/sso/:code",
      name: "authLoading",
      component: AuthLoadingScreen,
      props: true,
    },
    {
      path: "*",
      name: "404",
      redirect: "/",
    },
  ],
});